module.exports = __webpack_public_path__ + "static/media/bas.404527db.jpeg";